import { Caption, Flex, useStyles } from '@archipro-design/aria';
import * as S from './ImageCaptionArticle.style';
import parse from 'html-react-parser';

interface ImageCaptionArticleProps {
    text: string;
    isMain?: boolean;
}

const ImageCaptionArticle = ({ text, isMain }: ImageCaptionArticleProps) => {
    const { css } = useStyles();
    const captionStyle = isMain
        ? S.TagMainCaptionContainer
        : S.TagSubCaptionContainer;
    const captionAsReactElements = parse(text);

    return (
        <Flex className={css(captionStyle)}>
            <Caption variant="03-alt">{captionAsReactElements}</Caption>
        </Flex>
    );
};

export default ImageCaptionArticle;
